import React, { useState, useEffect } from 'react';
import { Container, Table, Button, Badge, Card, Form, InputGroup, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { FiPlus, FiUsers, FiEdit2, FiArrowLeft, FiSearch, FiFilter } from 'react-icons/fi';

const ParticipantManagement = () => {
    const [participants, setParticipants] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterDept, setFilterDept] = useState('');

    useEffect(() => {
        fetchParticipants();
    }, []);

    const fetchParticipants = async () => {
        try {
            const res = await api.get('/participants');
            setParticipants(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

    const departments = [...new Set(participants
        .map(p => p.departamento)
        .filter(d => d)
    )].sort();

    const filteredParticipants = participants.filter(p => {
        if (filterDept && p.departamento !== filterDept) return false;
        if (searchTerm && !p.nome.toLowerCase().includes(searchTerm.toLowerCase())) return false;
        return true;
    });

    return (
        <Container className="mt-4">
            <div className="d-flex align-items-center mb-4">
                <Button 
                    variant="link" 
                    as={Link} 
                    to="/dashboard" 
                    className="text-decoration-none p-0 mb-2 text-muted"
                >
                    <FiArrowLeft className="me-1" /> Voltar para Lista de treinamento
                </Button>
            </div>              
            <div className="d-flex justify-content-between align-items-center">
                <h2 className="mb-4 fw-bold" style={{ fontFamily: 'Nunito, sans-serif', color: '#006064' }}>
                    Gestão de Participantes
                </h2>
                <Button variant="success" as={Link} to="/participants/new" className="fw-bold">
                    <FiPlus className="me-1" /> Novo Participante
                </Button>
            </div>           
            
            <Card className="shadow-sm border-0 mb-4">
                <Card.Header className="bg-white py-3 border-bottom-0">
                    <Row className="g-3">
                        <Col md={6}>
                            <InputGroup>
                                <InputGroup.Text className="bg-light border-end-0"><FiSearch /></InputGroup.Text>
                                <Form.Control 
                                    placeholder="Buscar por nome..." 
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="border-start-0"
                                />
                            </InputGroup>
                        </Col>
                        <Col md={6}>
                            <InputGroup>
                                <InputGroup.Text className="bg-light border-end-0"><FiFilter /></InputGroup.Text>
                                <Form.Select 
                                    value={filterDept} 
                                    onChange={(e) => setFilterDept(e.target.value)}
                                    className="border-start-0"
                                >
                                    <option value="">Todos Departamentos</option>
                                    {departments.map(dept => (
                                        <option key={dept} value={dept}>{dept}</option>
                                    ))}
                                </Form.Select>
                            </InputGroup>
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body className="p-0">
                    <Table hover responsive className="mb-0">
                        <thead className="bg-light">
                            <tr>
                                <th className="border-0 text-muted small fw-bold text-uppercase ps-4" style={{ width: '80px' }}>Foto</th>
                                <th className="border-0 text-muted small fw-bold text-uppercase">Nome</th>
                                <th className="border-0 text-muted small fw-bold text-uppercase">Email</th>
                                <th className="border-0 text-muted small fw-bold text-uppercase">Departamento</th>
                                <th className="border-0 text-muted small fw-bold text-uppercase">Cargo</th>
                                <th className="border-0 text-muted small fw-bold text-uppercase">Status</th>
                                <th className="border-0 text-muted small fw-bold text-uppercase text-end pe-4">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredParticipants.map(p => (
                                <tr key={p.id} className="align-middle">
                                    <td className="ps-4">
                                        <div style={{ width: '40px', height: '40px', borderRadius: '50%', overflow: 'hidden', backgroundColor: '#e9ecef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            {p.foto_url ? (
                                                <img 
                                                    src={`${baseURL}${p.foto_url}`} 
                                                    alt={p.nome} 
                                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                    onError={(e) => {
                                                        e.target.style.display = 'none';
                                                        e.target.parentElement.innerHTML = '<svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="20" width="20" xmlns="http://www.w3.org/2000/svg" style="color: #6c757d;"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>';
                                                    }}
                                                />
                                            ) : (
                                                <FiUsers size={20} className="text-muted" />
                                            )}
                                        </div>
                                    </td>
                                    <td className="fw-bold text-dark">{p.nome}</td>
                                    <td className="text-muted">{p.email}</td>
                                    <td className="text-muted">{p.departamento}</td>
                                    <td className="text-muted">{p.cargo}</td>
                                    <td>
                                        <Badge bg={p.ativo ? 'success' : 'secondary'} className="fw-normal px-3 py-2 rounded-pill">
                                            {p.ativo ? 'Ativo' : 'Inativo'}
                                        </Badge>
                                    </td>
                                    <td className="text-end pe-4">
                                        <Button size="sm" variant="outline-primary" className="d-inline-flex align-items-center gap-1" as={Link} to={`/participants/${p.id}/edit`}>
                                            <FiEdit2 size={14} /> Editar
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default ParticipantManagement;